import script from "./CreateOrganizationsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateOrganizationsView.vue?vue&type=script&setup=true&lang=ts"

import "./CreateOrganizationsView.vue?vue&type=style&index=0&id=1cebf69e&lang=scss"

const __exports__ = script;

export default __exports__